import { parse } from 'query-string';
import { ofType } from 'redux-observable';
import { concat, defer, EMPTY, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { QUERY_LANGUAGE_KEY } from '@/modules/common/constants/queryParams';

import { deepSearchSetFilterByAction } from '../../../Search/redux/slices/deepSearch';
import { setAllowedChipTagTypes } from '../../helpers/chips';
import { getTabList } from '../../helpers/deepSearch';
import { isInternalType } from '../../helpers/embedCodeParams';
import logger from '../../helpers/logger';
import { fetchConfig } from '../../helpers/request';
import { setPlayerName } from '../../helpers/video';
import { configFetchStartAction, resetStoreAction, updateConfigAction } from '../slices/common';
import { getHashLocation, processHistoryObject } from '@/modules/common/helpers/history';

export default (action$) =>
  action$.pipe(
    ofType(configFetchStartAction.type),
    switchMap(() =>
      concat(
        of(resetStoreAction()),
        defer(() => fetchConfig()).pipe(
          mergeMap((config) => {
            const actions = [];

            const { search } = getHashLocation();
            const parsedSearch = parse(search);
            const queryLanguage = parsedSearch[QUERY_LANGUAGE_KEY];

            if (queryLanguage && !config.languages.find((lang$) => lang$.value === queryLanguage)) {
              delete parsedSearch[QUERY_LANGUAGE_KEY];

              const newURL = processHistoryObject({
                search: parsedSearch,
              });

              window.history.replaceState({}, '', `${window.location.pathname}${window.location.search}#${newURL}`);
            }

            logger.log('STORE config', config);
            if (config.status && !isInternalType) {
              config.channels.forEach(({ logo }) => {
                if (logo) {
                  const rel = 'preload';
                  const dataKey = `data-${rel}-href`;

                  if (!document.head.querySelector(`[${dataKey}="${logo}"]`)) {
                    const link = document.createElement('link');
                    link.setAttribute(dataKey, logo);
                    link.rel = rel;
                    link.href = logo;
                    link.as = 'image';

                    document.head.appendChild(link);
                  }
                }
              });
            }

            setAllowedChipTagTypes(config.tagTypes.slice());
            setPlayerName(config.player.name);

            if (config.deepSearch) {
              const [firstTab] = getTabList(config.dsTags);

              actions.push(of(deepSearchSetFilterByAction(firstTab.type)));
            }

            actions.push(of(updateConfigAction(config)));

            return concat(...actions);
          }),
          catchError(() => {
            logger.error('Can`t request config');

            return EMPTY;
          }),
        ),
      ),
    ),
  );
